import { motion } from "framer-motion";
import {
  FaCoins,
  FaHandHoldingUsd,
  FaUniversity,
  FaHome,
  FaUserTie,
  FaBolt,
} from "react-icons/fa";
import "./Services.css";

const services = [
  {
    icon: FaCoins,
    title: "Gold Loan",
    desc: "Instant cash against gold with the maximum loan value and lowest interest rates.",
  },
  {
    icon: FaHandHoldingUsd,
    title: "Personal Loan",
    desc: "Quick, unsecured funding for personal needs with minimal documentation.",
  },
  {
    icon: FaUniversity,
    title: "Business Loan",
    desc: "Working capital and expansion finance tailored to your business cycle.",
  },
  {
    icon: FaHome,
    title: "Property Loan",
    desc: "Leverage your property for higher-value loans with flexible repayment.",
  },
  {
    icon: FaUserTie,
    title: "Financial Guidance",
    desc: "One-to-one consultation to help you choose the right financial path.",
  },
  {
    icon: FaBolt,
    title: "Emergency Loan",
    desc: "Fast-track approvals for urgent financial requirements, when it matters most.",
  },
];

const Services = () => {
  return (
    <section id="services" className="section lf-services">
      <div className="container">
        <div className="section-head-center">
          <span className="eyebrow">What We Offer</span>
          <h2 className="section-heading">
            Our <span className="accent-text">Services</span>
          </h2>
          <p className="section-subtext">
            A complete range of financial solutions designed around your needs —
            secure, transparent, and fast.
          </p>
        </div>

        <div className="lf-services__grid">
          {services.map(({ icon: Icon, title, desc }, i) => (
            <motion.div
              key={title}
              className="lf-services__card"
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <span className="lf-services__border" />
              <span className="lf-services__icon">
                <Icon />
              </span>
              <h3>{title}</h3>
              <p>{desc}</p>
              <span className="lf-services__link">Learn more →</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
